import type { PlacementBackendRuntimeResult } from '../types';
import type { DefaultPlacementMiddlewareFactory } from './types';
import { flattenMessagesForFrontend } from '../util/flatten-messages-for-frontend';

export const createDefaultPlacementMiddleware: DefaultPlacementMiddlewareFactory =
	(execute) =>
	(params) =>
	async ({ request, koa, postOffice, placement }) => {
		try {
			const result = await execute({ request, koa, postOffice, placement, params });

			koa.ctx.body = result;

			koa.ctx.status = 200;
		} catch (error) {
			request.logger.error({ error }, 'placement middleware error');

			koa.ctx.status = 500;

			koa.ctx.body = {
				message: 'An error occurred',
			};
		}
	};

export const defaultPlacementMiddleware = createDefaultPlacementMiddleware(
	async ({ postOffice }) => {
		const result = await postOffice.messagesRuntime();

		heuristicForPostOfficeFailure(result);

		return {
			...result.data,
			messages: flattenMessagesForFrontend(result.data.messages),
		};
	},
);

export const heuristicForPostOfficeFailure = ({
	errors,
	data,
}: PlacementBackendRuntimeResult): void => {
	const { messages } = data;

	if (!(messages.length > 1)) return;

	const uniqueErrorIds = new Set(errors.map((e) => e?.messageTemplateId ?? 'unknown'));
	const uniqueMessageIds = new Set(messages.map((e) => e.messageTemplateId));

	if (uniqueErrorIds.size > 1 && uniqueMessageIds.size / uniqueMessageIds.size > 0.1) {
		// Better error required
		throw new Error('too many message template errors');
	}
};

export { flattenMessagesForFrontend };
